const _excluded = ["idx", "footer", "error"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import cn from 'classnames';
import ServiceDetails from "../ServiceDetails/ServiceDetails";
import styles from "./ServicePanel.module.scss";
export const getTestId = idx => "service-panel-".concat(idx, "-");
const ServicePanel = /*#__PURE__*/React.forwardRef(function ServicePanel(props, ref) {
  const {
      idx,
      footer,
      error
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const testid = getTestId(idx);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-testid": "".concat(testid, "container-").concat(idx),
    "aria-invalid": error,
    className: cn(styles.mainContainer, {
      [styles.error]: error
    })
  }, /*#__PURE__*/React.createElement(ServiceDetails, _extends({}, rest, {
    testid: testid
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, footer));
});
export default ServicePanel;